import { RefreshCw } from 'lucide-react';
import { Button } from 'components';
import {
  WarningBannerBox,
  WarningBannerContent,
  WarningBannerDescription,
  WarningBannerIcon,
  WarningBannerTextBlock,
  WarningBannerTitle,
} from './WarningBanner.styles';

interface WarningBannerProps {
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
  isActing?: boolean;
  role?: 'alert' | 'status';
}

export function WarningBanner({
  title,
  description,
  actionLabel,
  onAction,
  isActing = false,
  role = 'alert',
}: WarningBannerProps) {
  return (
    <WarningBannerBox role={role}>
      <WarningBannerContent>
        <WarningBannerIcon />
        <WarningBannerTextBlock>
          <WarningBannerTitle>{title}</WarningBannerTitle>
          <WarningBannerDescription>{description}</WarningBannerDescription>
        </WarningBannerTextBlock>
      </WarningBannerContent>
      <Button
        variant="secondary"
        onClick={onAction}
        disabled={isActing}
        className="shrink-0 bg-white"
      >
        <RefreshCw className={`h-4 w-4 mr-1.5 ${isActing ? 'animate-spin' : ''}`} />
        {actionLabel}
      </Button>
    </WarningBannerBox>
  );
}
